{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/PACSLAC-D",
	"name": "PACSLAC-D",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "PACSLAC-D",
	"purpose": "Évaluation de la douleur chez les personnes atteintes de démence",
	"description": "L’échelle PACSLAC consiste en un système d’évaluation dichotomique (0 = absence de douleur, 1 = douleur) et n’est scorée qu’en présence d’un des facteurs.",
	"item": [
		{
			"linkId": "70100",
			"text": "Visage",
			"type": "group",
			"item": [
				{
					"linkId": "70200",
					"text": "Expression de douleur",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70201",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70202",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70300",
					"text": "Un son ou une vocalisation spécifique de douleur « aïe » ou « ouf »",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70301",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70302",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70400",
					"text": "Froncement des sourcils",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70401",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70402",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70500",
					"text": "Grimace",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70501",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70502",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70600",
					"text": "Plissement du front",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70601",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70602",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70700",
					"text": "Gémir et geindre",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70701",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70702",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70800",
					"text": "Changement dans les yeux (loucher, terne, brillant, mouvements accrus)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70801",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70802",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "70900",
					"text": "Toucher et tenir la zone douloureuse",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "70901",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "70902",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71000",
					"text": "Protéger la zone douloureuse",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71001",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71002",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71100",
					"text": "Se retirer",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71101",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71102",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "71200",
			"text": "Résistance/défense",
			"type": "group",
			"item": [
				{
					"linkId": "71300",
					"text": "Agression verbale",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71301",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71302",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71400",
					"text": "Agression physique (p.ex. repousser des personnes et/ou des objets, griffer autrui, frapper autrui, donner des coups de poing, donner des coups de pied)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71401",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71402",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71500",
					"text": "Agacé (agité)",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71501",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71502",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71600",
					"text": "Reculer",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71601",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71602",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71700",
					"text": "Ne pas vouloir être touché",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71701",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71702",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "71800",
					"text": "Non coopératif / résistant aux soins",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "71801",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "71802",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		},
		{
			"linkId": "71900",
			"text": "Social-émotionnel/humeur",
			"type": "group",
			"item": [
				{
					"linkId": "72000",
					"text": "Grincheux/irritable",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72001",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72002",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72100",
					"text": "Crier/hurler",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72101",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72102",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72200",
					"text": "Regard sombre",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72201",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72202",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72300",
					"text": "Regard triste",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72301",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72302",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72400",
					"text": "Ne pas laisser les gens s’approcher",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72401",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72402",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72500",
					"text": "Bouleversé",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72501",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72502",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72600",
					"text": "Visage rougi",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72601",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72602",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				},
				{
					"linkId": "72700",
					"text": "Agité",
					"type": "choice",
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
							"valueCodeableConcept": {
								"coding": [
									{
										"system": "http://hl7.org/fhir/questionnaire-item-control",
										"code": "radio-button",
										"display": "Radio Button"
									}
								]
							}
						}
					],
					"required": true,
					"answerOption": [
						{
							"valueCoding": {
								"code": "72701",
								"display": "Oui"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 1
								}
							]
						},
						{
							"valueCoding": {
								"code": "72702",
								"display": "Non"
							},
							"extension": [
								{
									"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
									"valueDecimal": 0
								}
							]
						}
					]
				}
			]
		}
	]
}
